import { TripSecurityTable } from '../../global/interfaces';
import {
  GET_SECURITY_TRIPS_REQUEST,
  GET_SECURITY_UNLOADING_TRIPS_REQUEST,
  GET_SECURITY_TRIPS_SUCCESS,
  GET_SECURITY_TRIPS_ERROR,
} from './constants';

export const getTripsRequest = () => ({
  type: GET_SECURITY_TRIPS_REQUEST,
});

export const getUnloadingTripsRequest = () => ({
  type: GET_SECURITY_UNLOADING_TRIPS_REQUEST,
});

export const getTripsSuccess = (trips: TripSecurityTable[]) => ({
  type: GET_SECURITY_TRIPS_SUCCESS,
  payload: { trips },
});

export const getTripsError = (error: Error | null) => ({
  type: GET_SECURITY_TRIPS_ERROR,
  payload: { error },
});

export type Actions =
  | ReturnType<typeof getTripsRequest>
  | ReturnType<typeof getUnloadingTripsRequest>
  | ReturnType<typeof getTripsSuccess>
  | ReturnType<typeof getTripsError>;
